import React, { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import { getRedirectUrl } from '@outdoorly/util';

import { useAuth } from '../providers/auth';
import { SignUp } from '../components/login';

const SignUpPage = () => {
  const router = useRouter();
  const auth = useAuth();
  const [isRedirecting, setRedirecting] = useState(false);

  const redirectTo = getRedirectUrl(router.query.next_url);
  const invitationCode = router.query.invitation_code;

  useEffect(() => {
    router.prefetch(redirectTo);
  }, [router, redirectTo]);

  const onSignUp = useCallback(() => {
    setRedirecting(true);
    router.push(redirectTo);
  }, [router, setRedirecting, redirectTo]);

  useEffect(() => {
    if (auth.isAuthed) {
      onSignUp();
    }
  }, [auth.isAuthed, onSignUp]);

  return (
    <SignUp
      isLoading={isRedirecting}
      handleLoginClick={() => {
        router.push('/login');
      }}
      handleCloseClick={() => {
        router.back();
      }}
      invitationCode={invitationCode}
    />
  );
};

export default SignUpPage;
